import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import { Button } from '@progress/kendo-react-buttons';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';

import PublicationList from './list/publicationList';
import PublicationListFilters from './filters/publicationListFilters';
import PublicationListSummary from './list/publicationListSummary';
import PublicationSearch from './filters/publicationSearch';
import { getPublications, getPublicationFilters, exportPublications } from './publication.actions';
import { getDefaultRequestBuilder, availablePublicationStatuses } from '../common/sponsorships/filters/filterHelper';
import { useAuth0, getSelectedTenantId } from '../app/auth';
import LoadingIndicator from '../common/loadingIndicator';
import { metricName } from '../common/constants';

const PublicationIndexComponent = ({isExporting, onComponentMount, onExport}) => {

  const [dialogVisible, setDialogVisible] = useState(false);
  const { getTokenSilently, user } = useAuth0();

  useEffect(() => {    
    const notifyComponentMount = async() => {
      const token = await getTokenSilently();
      const builder = getDefaultRequestBuilder();
      onComponentMount({
        pageNumber: 1,
        pageSize: 150,
        metrics: [metricName.clicks, metricName.views, metricName.cpm, metricName.cpc, metricName.ctr, metricName.conversions],
        aggregateMetrics: [metricName.views, metricName.cpm, metricName.clicks, metricName.cpc, metricName.ctr],
        sortByField: 'date',
        sortByDirection: 'desc',
        filterQueryString: builder.getQueryString()
      }, token, getSelectedTenantId(user, token));
    };
    notifyComponentMount();
  });

  const toggleDialog = () => {
    setDialogVisible(!dialogVisible);
  };

  const handleExportRequest = async(event) => {
    event.preventDefault();
    const formatFieldName = (fieldName) => `performance_metrics.${fieldName}`;

    const exportFields = ['date', 'channel.name', 'channel.medium_channel_id', 
                          'publication_status.name','medium_publication_id', 'price' ,
                          formatFieldName(metricName.views), formatFieldName(metricName.cpm),
                          formatFieldName(metricName.clicks), formatFieldName(metricName.cpc),
                          formatFieldName(metricName.conversions)];
    const token = await getTokenSilently();
    onExport(exportFields, token, getSelectedTenantId(user, token));
    toggleDialog();
  };

  if(isExporting) {
    return <LoadingIndicator/>;
  }

  return (
      <div id="publications-container">
        <div className="title-container">
          <h1>Publication Tracker</h1>
          <div className="actions export-area">
              <Button look="bare" icon="hyperlink-open" onClick={handleExportRequest}>Export</Button>
          </div>
        </div>
        <div className="publication-list-container">
          <div className="filters">
            <PublicationListFilters />
          </div>
          <div className="list">
            <PublicationSearch />
            <PublicationListSummary />
            <PublicationList />
          </div>
        </div>

        {dialogVisible && 
          <Dialog title="Exporting data" onClose={toggleDialog}>
            <p style={{ margin: "25px", textAlign: "center" }}>
              You will receive a Slack notification with a link to download the file. <br/>
              It will take around 5 minutes.
            </p>
            <DialogActionsBar>
                <button className="k-button k-primary" onClick={toggleDialog}>OK</button>
            </DialogActionsBar>
          </Dialog>
        }
      </div>
    );
};

function mapDispatchToProps(dispatch) {
  const props = {
    onExport: (exportFields, token, tenantId) => dispatch(exportPublications(exportFields, token, tenantId)),
    onComponentMount: (options, token, tenantId) => {
      dispatch(getPublicationFilters(availablePublicationStatuses, token, tenantId));
      dispatch(getPublications(options, token, tenantId));
    }
  };
  return props;
}

const PublicationIndex = connect(null, mapDispatchToProps)(PublicationIndexComponent);
export default PublicationIndex;